import styled from "@emotion/styled";

export const ProductTitle = styled.h1`
  font-size: 2.25rem;
  margin-bottom: 15px;
  word-wrap: break-word;
  font-weight: 400;
  margin: 0 0 0.5rem;
  line-height: 1.4;
`;

export const ProductDescription = styled.div`
  margin-top: 40px;
  font-weight: 300;
  margin-bottom: 2rem;
  border-bottom: 5px solid black;
`;
